/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AuditLog = {
  /**
   * The registered OAuth client the call authenticated as, when it had one. Absent for calls that carried no OAuth client.
   */
  actingClientId?: string | undefined;
  /**
   * How the change was made: 'dashboard', 'api_key', 'platform_mcp', 'project_assistant', or 'unknown' when no surface was identifiable. Always present.
   */
  actingSurface: string;
  action: string;
  actorDisplayName?: string | undefined;
  actorId: string;
  actorSlug?: string | undefined;
  actorType: string;
  afterSnapshot?: any | undefined;
  beforeSnapshot?: any | undefined;
  /**
   * The creation date of the audit log.
   */
  createdAt: Date;
  id: string;
  metadata?: { [k: string]: any } | undefined;
  projectId?: string | undefined;
  projectSlug?: string | undefined;
  subjectDisplayName?: string | undefined;
  subjectId: string;
  subjectSlug?: string | undefined;
  subjectType: string;
};

/** @internal */
export const AuditLog$inboundSchema: z.ZodMiniType<AuditLog, unknown> = z.pipe(
  z.object({
    acting_client_id: z.optional(z.string()),
    acting_surface: z.string(),
    action: z.string(),
    actor_display_name: z.optional(z.string()),
    actor_id: z.string(),
    actor_slug: z.optional(z.string()),
    actor_type: z.string(),
    after_snapshot: z.optional(z.any()),
    before_snapshot: z.optional(z.any()),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    metadata: z.optional(z.record(z.string(), z.any())),
    project_id: z.optional(z.string()),
    project_slug: z.optional(z.string()),
    subject_display_name: z.optional(z.string()),
    subject_id: z.string(),
    subject_slug: z.optional(z.string()),
    subject_type: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "acting_client_id": "actingClientId",
      "acting_surface": "actingSurface",
      "actor_display_name": "actorDisplayName",
      "actor_id": "actorId",
      "actor_slug": "actorSlug",
      "actor_type": "actorType",
      "after_snapshot": "afterSnapshot",
      "before_snapshot": "beforeSnapshot",
      "created_at": "createdAt",
      "project_id": "projectId",
      "project_slug": "projectSlug",
      "subject_display_name": "subjectDisplayName",
      "subject_id": "subjectId",
      "subject_slug": "subjectSlug",
      "subject_type": "subjectType",
    });
  }),
);

export function auditLogFromJSON(
  jsonString: string,
): SafeParseResult<AuditLog, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuditLog$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuditLog' from JSON`,
  );
}
